import { inject } from '../utils/index';

const defaultState = {
  isLoading: false,
  ready: false,
  reservations: [],
  hasError: false,
};

class ReservationController {
  constructor(gems, stateFactory) {
    this.gems = gems;
    this.state = stateFactory('reservations', defaultState);
  }

  getReservationById(id) {
    const {
      reservations,
    } = this.state.value;

    return reservations ? reservations.find(item => item.id === id) : null;
  }

  async getAllReservations() {
    this.state.update({ isLoading: true });

    try {
      const reservations = await this.gems.getAllReservations();

      this.state.update({
        isLoading: false,
        ready: true,
        reservations,
        hasError: false,
      });
      this.state.save();
    } catch (error) {
      console.error(error);
      this.state.update({ hasError: error });
    }
  }

  getState() {
    return this.state;
  }
}

inject(ReservationController, ['GEMSService', 'StateFactory']);
export default ReservationController;



// WEBPACK FOOTER //
// ./src/controllers/ReservationController.js